import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Pagination from "@mui/material/Pagination";
import { Spin } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowDown,
  faArrowUp,
  faCloudDownload,
} from "@fortawesome/free-solid-svg-icons";

import TobNavBar from "../../DashBaord/Top_navbar";

import moment from "moment";
import SkeltonList from "../../../components/SkeltonEffect/list";
import {
  analizeWinners,
  analyzeWinnersList,
  sentAnalyserEmail,
} from "../../../controllers/V1/analyserControllers";
import {
  list as campaignList,
  prizeList,
} from "../../../controllers/V1/campaignController";
import { list as getGeneralData } from "../../../controllers/V1/generalDataController.js";
import * as XLSX from "xlsx";
import Loading from "../../../components/Loading/LoadingEffect";
import PreviewPopUp from "./PreviewPopUp";
import FinalPopup from "./FinalPopUp";
import { useNavigate } from "react-router-dom";
import { formatProjectDate } from "../../../controllers/common.js";
import { usePermissions } from "../../../controllers/PermissionContext";
import { getCurrentAdmin } from "../../../controllers/accounts/Account.js";
import UserSelectWithSearch from "../../../components/UserDetailsSelectWithSearch.js";
import AreaMultiSelect from "./AreaMultiSelect.js";
import ManageAreasPopup from "./ManageAreasPopup";
import { DEFAULT_AREASLIST } from "./areasList.js";
// import { getGeneralDataRecord, saveGeneralData } from "../../../controllers/V1/generalDataController.js";
function VendorList(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

VendorList.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export default function BasicTabs() {
  const navigate = useNavigate();
  const [error, setError] = useState({});
  const PERMISSION = usePermissions("analyser");
  /************************************************************************************* */
  const [pageLoading, setPageLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [isAnalyseAllow, setIsAnalyseAllow] = useState(false);
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const targetRef = useRef(null);
  const winningCouponRef = useRef(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [campaignListData, setCampaignListData] = useState([]);
  const [ALLLISTDATA, setListData] = useState([]);
  const [PRIZEDATA, setPrizeData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [TOTALPAGES, setTotalPages] = useState(1);
  const [LIMIT, setLimit] = useState(20);
  const [SKIP, setSkip] = useState(0);
  const [searchParams, setSearchParams] = useState({});

  const [usersDetails, setUsersDetails] = useState([]);
  const [orderStatic, setOrderStatic] = useState({});
  const [otherData, setOtherData] = useState({});

  const [sortConfig, setSortConfig] = useState("desc");
  const [searchValue, setSearchValue] = useState("");
  const [viewData, setViewData] = useState([]);
  const [matchingCode, setMatchingCode] = useState("");
  const [finalData, setFinalData] = useState([]);
  const [selectedCampaign, setSelectedCampaign] = useState({});
  const [amount, setAmount] = useState("");
  const [selectedAreas, setSelectedAreas] = useState([]);
  const [analyserAreas, setAnalyserAreas] = useState(DEFAULT_AREASLIST);
  const [manageAreasOpen, setManageAreasOpen] = useState(false);
  const [areasSaving, setAreasSaving] = useState(false);
  const [EXPORTDATA, setExportData] = useState([]);
  const [exportLoadingText, setExportLoadingText] = useState(
    "Preparing data, please wait...",
  );
  const [enableDrawTimeRestriction, setEnableDrawTimeRestriction] = useState("N");

  const [selectedStraightUsers, setSelectedUsers] = useState([]);
  const [selectedRumbleUsers, setSelectedRumbleUsers] = useState([]);
  
  const [selectedMatchUsers, setSelectedMatchUsers] = useState({
    7: [],
    6: [],
    5: [],
    4: [],
    3: [],
    2: [],
    1: [],
  });

  const [selectedStraightArea, setSelectedStraightArea] = useState([]);
  const [selectedRumbleArea, setSelectedRumbleArea] = useState([]);
  
  const [selectedMatchArea, setSelectedMatchArea] = useState({
    7: [],
    6: [],
    5: [],
    4: [],
    3: [],
    2: [],
    1: [],
  });
  
  
  /*********************************************************
   *  This function is for handle page change
   *********************************************************/
  const handlePageChange = (event, newPage) => {
    console.log("newPage : ", newPage);
    setCurrentPage(newPage);
    // setSkip((newPage - 1) * LIMIT);
    targetRef.current.scrollIntoView({
      behavior: "smooth",
    });
  };

  const loadAnalyserAreas = async () => {
    try {
      // const res = await getGeneralDataRecord();
      // if (res?.status === true && Array.isArray(res?.result?.analyser_areas)) {
      //   if (res.result.analyser_areas.length > 0) {
      //     setAnalyserAreas(res.result.analyser_areas);
      //   }
      // }
    } catch (error) {
      console.log("loadAnalyserAreas error", error);
    }
  };

  const handleSaveAreas = async (updatedAreas) => {
    try {
      setAreasSaving(true);
      setAnalyserAreas(updatedAreas);
      setSelectedAreas((prev) =>
        prev.filter((area) => updatedAreas.includes(area)),
      );
      return true;
      // const res = await saveGeneralData({ analyser_areas: updatedAreas });
      // if (res?.status === true) {
      // }
      // notification.open({
      //   message: "Error",
      //   description: res?.message || "Failed to save areas.",
      //   placement: "topRight",
      //   icon: <InfoCircleOutlined style={{ color: "red" }} />,
      //   duration: 2,
      // });
      return false;
    } catch (error) {
      console.log("handleSaveAreas error", error);
      return false;
    } finally {
      setAreasSaving(false);
    }
  };

  const getCampaignList = async () => {
    try {
      setIsLoading(true);
      setPageLoading(true);
      const options = {
        type: "",
        condition: {
          status: "A",
          lotto_type: { $lt: 8 },
          show_on: { $in: ["POS", "App"] },
          // enable_raffle_ticket : "Disable"
        },
        select: { title: true, lotto_type: true },
        skip: 0,
        limit: 0,
      };
      const res = await campaignList(options);
      if (res.status === true) {
        setCampaignListData(res.result);
      }
      setIsLoading(false);
      setPageLoading(false);
    } catch (error) {
      setPageLoading(false);
    }
  };

  const fetchAdminProfile = async () => {
    try {
      const res = await getCurrentAdmin();
      if (res.status === true && res.result) {
        return res.result;
      }
      return null;
    } catch (error) {
      console.log("error", error);
      return null;
    }
  };

  const fetchGeneralDataSettings = async () => {
    try {
      const option = {
        type: "Single",
        condition: {},
        select: {
          analyser_start_time: true,
          analyser_end_time: true,
        },
      };
      const res = await getGeneralData(option);
      if (res.status === true) {
        return res.result;
      }
      return null;
    } catch (error) {
      console.log("error", error);
      return null;
    }
  };

  const fetchGeneralData = async () => {
    try {
      const result = await fetchGeneralDataSettings();
      if (result) {
        const adminInfo =
          (await fetchAdminProfile()) ||
          JSON.parse(sessionStorage.getItem("ADMIN-INFO") || "{}");
        setEnableDrawTimeRestriction(adminInfo?.draw_time_restriction || "N");
        const { analyser_end_time, analyser_start_time } = result;
        if (!analyser_end_time || !analyser_start_time) {
          alert("Please add analyser working time in General Data.");
          navigate("/dashboard");
        } else {
          const analyserStartHr = parseInt(
            moment(`2025-02-23 ${analyser_start_time}`).format("HH"),
          );
          const analyserStartMin = parseInt(
            moment(`2025-02-23 ${analyser_start_time}`).format("mm"),
          );
          const analyserTotalStartMin = analyserStartHr * 60 + analyserStartMin;

          const analyserEndHr = parseInt(
            moment(`2025-02-23 ${analyser_end_time}`).format("HH"),
          );
          const analyserEndMin = parseInt(
            moment(`2025-02-23 ${analyser_end_time}`).format("mm"),
          );
          const analyserTotalEndMin = analyserEndHr * 60 + analyserEndMin;

          // const now = new Date();
          // const currentHr = parseInt(moment(now).format('HH'));
          // const currentMin = parseInt(moment(now).format('mm'));
          // const constCurrentMin = currentHr * 60 + currentMin;

          const now = new Date();
          const currentTIme = await formatProjectDate(now);
          const constCurrentMin =
            parseInt(moment(currentTIme).format("H")) * 60 +
            parseInt(moment(currentTIme).format("m"));

          if (
            analyserTotalStartMin < constCurrentMin &&
            analyserTotalEndMin > constCurrentMin
          ) {
            // console.log('in between')
          } else {
            alert("Access denied! Please come on time.");
            navigate("/dashboard");
          }
        }
      }
    } catch (error) {
      console.log("error", error);
    }
  };
  /*********************************************************
   *  This function will load when page load and with dependency update
   *********************************************************/
  useEffect(() => {
    getCampaignList();
    fetchGeneralData();
    targetRef.current.scrollIntoView({
      behavior: "smooth",
    });
    document.title = "U-Winn CRM || Lotto Winner's Analyser";
  }, []);

  const [PARAMS, setParams] = useState({});
  const handleChange = (e) => {
    const { name, value } = e.target;
    setParams((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const analyzeWinnerData = async (e) => {
    e.preventDefault();
    try {
      setPageLoading(true);
      setFilteredData([]);
      setListData([]);
      setExportData([]);
      const straightUsersPOS = [];
      const rumbleUsersPOS = [];

      const matchUsersPOS = {};
      const match7UserPOS = [];
      const match6UserPOS = [];
      const match5UserPOS = [];
      const match4UserPOS = [];
      const match3UserPOS = [];
      
      const straightUsersArea = [];
      const rumbleUsersArea = [];

      const matchUsersArea = {};
      const match7UserArea = [];
      const match6UserArea = [];
      const match5UserArea = [];
      const match4UserArea = [];
      const match3UserArea = [];
     
      if(selectedStraightUsers && selectedStraightUsers.length > 0){
        selectedStraightUsers.forEach((user) => {
          const userData = JSON.parse(user);
          if (userData.pos_number) {
            straightUsersPOS.push(userData.pos_number);
          }
        });
      }
      if(selectedStraightArea && selectedStraightArea.length > 0){
        selectedStraightArea.forEach((area) => {
          straightUsersArea.push(area);
        });
      }

      if(selectedRumbleUsers && selectedRumbleUsers.length > 0){
        selectedRumbleUsers.forEach((user) => {
          const userData = JSON.parse(user);
          if (userData.pos_number) {
            rumbleUsersPOS.push(userData.pos_number);
          }
        });
      }
      if(selectedRumbleArea && selectedRumbleArea.length > 0){
        selectedRumbleArea.forEach((area) => {
          rumbleUsersArea.push(area);
        });
      }

      if(selectedMatchUsers && Object.keys(selectedMatchUsers).length > 0){
        Object.keys(selectedMatchUsers).forEach((key) => {
          const users = selectedMatchUsers[key];
          if (users && users.length > 0) {
            console.log("users : ", users);
            matchUsersPOS[key] = users;
          }
        });
      }
      if(selectedMatchArea && Object.keys(selectedMatchArea).length > 0){
        Object.keys(selectedMatchArea).forEach((key) => {
          const areas = selectedMatchArea[key];
          if (areas && areas.length > 0) {
            matchUsersArea[key] = areas;
          }
        });
      }
      if(matchUsersPOS[7] && matchUsersPOS[7].length > 0){
        matchUsersPOS[7].forEach((user) => {
          const userData = JSON.parse(user);
          if (userData.pos_number) {
            match7UserPOS.push(userData.pos_number);
          }
        });
      }
      if(matchUsersArea[7] && matchUsersArea[7].length > 0){
        matchUsersArea[7].forEach((area) => {
          match7UserArea.push(area);
        });
      }
      if(matchUsersPOS[6] && matchUsersPOS[6].length > 0){
        matchUsersPOS[6].forEach((user) => {
          const userData = JSON.parse(user);
          if (userData.pos_number) {
            match6UserPOS.push(userData.pos_number);
          }
        });
      }
      if(matchUsersArea[6] && matchUsersArea[6].length > 0){
        matchUsersArea[6].forEach((area) => {
          match6UserArea.push(area);
        });
      }
      if(matchUsersPOS[5] && matchUsersPOS[5].length > 0){
        matchUsersPOS[5].forEach((user) => {
          const userData = JSON.parse(user);
          if (userData.pos_number) {
            match5UserPOS.push(userData.pos_number);
          }
        });
      }
      if(matchUsersArea[5] && matchUsersArea[5].length > 0){
        matchUsersArea[5].forEach((area) => {
          match5UserArea.push(area);
        });
      }

      if(matchUsersPOS[4] && matchUsersPOS[4].length > 0){
        matchUsersPOS[4].forEach((user) => {
          const userData = JSON.parse(user);
          if (userData.pos_number) {
            match4UserPOS.push(userData.pos_number);
          }
        });
      }
      if(matchUsersArea[4] && matchUsersArea[4].length > 0){
        matchUsersArea[4].forEach((area) => {
          match4UserArea.push(area);
        });
      }

      if(matchUsersPOS[3] && matchUsersPOS[3].length > 0){
        matchUsersPOS[3].forEach((user) => {
          const userData = JSON.parse(user);
          if (userData.pos_number) {
            match3UserPOS.push(userData.pos_number);
          }
        });
      }
      if(matchUsersArea[3] && matchUsersArea[3].length > 0){
        matchUsersArea[3].forEach((area) => {
          match3UserArea.push(area);
        });
      }
      const formData = new FormData(e.target);
      if (!formData.get("campaign")) {
        setError((pre) => ({
          ...pre,
          campaign: "Campaign is required.",
        }));
      } else if (!formData.get("draw_date")) {
        setError((pre) => ({
          ...pre,
          draw_date: "Draw Date is required.",
        }));
      } else if (!PRIZEDATA) {
        setError((pre) => ({
          ...pre,
          campaign: "Prize not fount.",
        }));
      } else {
        // const campaignData = formData.get('campaign').split('____') || [];
        const campaignData = JSON.parse(formData.get("campaign"));

        // const orderStaticOption = {
        //   campaignId : campaignData?.products_id,
        //   date : formData.get('draw_date')
        // }
        // getOrderStatics(orderStaticOption);

        const emailOption = {
          game_name: campaignData?.title || "N/A",
          draw_date: formData.get("draw_date"),
        };
        await sentAnalyserEmail(emailOption);

        const finalParam = {
          game_id: campaignData?.products_id,
          draw_date: formData.get("draw_date"),
          ...(formData.get("coupon")
            ? {
                coupon: formData.get("coupon"),
                user_details: true,
              }
            : {
                coupon: "",
                user_details: false,
              }),
          price: {
            ...(parseInt(PARAMS?.lotto_type) === 5 ||
            parseInt(PARAMS?.lotto_type) === 4 ||
            parseInt(PARAMS?.lotto_type) === 3
              ? {
                  straight: formData.get("stright_prize") || 0,
                  straight_super_ball: formData.get("straight_super_ball") || 0,
                  rumble: formData.get("rumble_mix_prize") || 0,
                  rumble_super_ball: formData.get("rumble_super_ball") || 0,
                }
              : {
                  straight: 0,
                  rumble: 0,
                }),
            chance_super_ball: parseInt(formData.get("chance_super_ball")) || 0,
            match1: parseInt(formData.get("reverse_1")) || 0,
            match2: parseInt(formData.get("reverse_2")) || 0,
            match3: parseInt(formData.get("reverse_3")) || 0,
            match4: parseInt(formData.get("reverse_4")) || 0,
            match5: parseInt(formData.get("reverse_5")) || 0,
            match6: parseInt(formData.get("reverse_6")) || 0,
            match7: parseInt(formData.get("reverse_7")) || 0,
          },
          page: currentPage || 1,
          order_by: sortConfig === "asc" ? -1 : 1,
          filter: {
            ...(formData.get("filter_straight_super_ball") && {
              straight_super_ball: formData.get("filter_straight_super_ball"),
            }),
            ...(formData.get("straight_super_ball_number") && {
              straight_super_ball_number: formData.get(
                "straight_super_ball_number",
              ),
            }),

            ...(formData.get("filter_rumble_super_ball") && {
              rumble_super_ball: formData.get("filter_rumble_super_ball"),
            }),
            ...(formData.get("rumble_super_ball_number") && {
              rumble_super_ball_number: formData.get(
                "rumble_super_ball_number",
              ),
            }),

            ...(formData.get("filter_chance_super_ball") && {
              chance_super_ball: formData.get("filter_chance_super_ball"),
            }),
            ...(formData.get("chance_super_ball_number") && {
              chance_super_ball_number: formData.get(
                "chance_super_ball_number",
              ),
            }),

            ...(formData.get("filter_straight") && {
              straight: formData.get("filter_straight"),
            }),
            ...(formData.get("straight_number") && {
              straight_number: formData.get("straight_number"),
            }),
            ...(formData.get("filter_rumble") && {
              rumble: formData.get("filter_rumble"),
            }),
            ...(formData.get("rumble_number") && {
              rumble_number: formData.get("rumble_number"),
            }),

            ...(formData.get("match1") && { match1: formData.get("match1") }),
            ...(formData.get("match1_number") && {
              match1_number: formData.get("match1_number"),
            }),
            ...(formData.get("match2") && { match2: formData.get("match2") }),
            ...(formData.get("match2_number") && {
              match2_number: formData.get("match2_number"),
            }),
            ...(formData.get("match3") && { match3: formData.get("match3") }),
            ...(formData.get("match3_number") && {
              match3_number: formData.get("match3_number"),
            }),
            ...(formData.get("match4") && { match4: formData.get("match4") }),
            ...(formData.get("match4_number") && {
              match4_number: formData.get("match4_number"),
            }),
            ...(formData.get("match5") && { match5: formData.get("match5") }),
            ...(formData.get("match5_number") && {
              match5_number: formData.get("match5_number"),
            }),
            ...(formData.get("match6") && { match6: formData.get("match6") }),
            ...(formData.get("match6_number") && {
              match6_number: formData.get("match6_number"),
            }),
            ...(formData.get("match7") && { match7: formData.get("match7") }),
            ...(formData.get("match7_number") && {
              match7_number: formData.get("match7_number"),
            }),
          },
          ...(amount && parseInt(amount) > 0 && { amount: parseInt(amount) }),
          straight_pos: straightUsersPOS || [],
          rumble_pos: rumbleUsersPOS || [],

          match_3_pos: match3UserPOS || [],
          match_4_pos: match4UserPOS || [],
          match_5_pos: match5UserPOS || [],
          match_6_pos: match6UserPOS || [],
          match_7_pos: match7UserPOS || [],

          straight_area: straightUsersArea || [],
          rumble_area: rumbleUsersArea || [],
          match_3_area: match3UserArea || [],
          match_4_area: match4UserArea || [],
          match_5_area: match5UserArea || [],
          match_6_area: match6UserArea || [],
          match_7_area: match7UserArea || [],
        };
        const res = await analyzeWinnersList(finalParam);
        if (res?.status === true) {
          setSearchParams(finalParam);
          const finalData = res.result?.finaldata;
          setListData(finalData || []);
          if (formData.get("coupon")) {
            setMatchingCode(formData.get("coupon"));
            setViewData(finalData);
          } else {
            setMatchingCode("");
            setViewData("");
          }
          setFilteredData(finalData);
          setTotalPages(res.result?.total_pages || 0);
          setOrderStatic(res.result?.total_ticket || 0);
          setOtherData((pre) => ({
            ...pre,
            draw_date : formData.get("draw_date"),
            total_ticket: res.result?.total_ticket,
            total_sales:
              res.result?.total_ticket *
                selectedCampaign?.straight_add_on_amount || 0,
          }));
          setExportLoadingText(
            `Preparing ~ ${100}/${res.result?.total_data} rows, please wait...`,
          );
        }
      }
      setPageLoading(false);
    } catch (error) {
      setPageLoading(false);
      console.log(error, "error");
    }
  };

  const loadMoreData = async () => {
    try {
      setPageLoading(true);
      setFilteredData([]);
      setListData([]);

      if (!searchParams?.game_id && !searchParams?.draw_date) {
        setError((pre) => ({
          ...pre,
          campaign: "Analyse Again.",
        }));
      } else {
        const finalParam = {
          ...searchParams,
          page: currentPage || 1,
          order_by: sortConfig === "asc" ? -1 : 1,
        };
        const res = await analyzeWinnersList(finalParam);
        if (res?.status === true) {
          setSearchParams(finalParam);

          const finalData = res.result?.finaldata;
          setListData(finalData || []);
          if (searchParams?.coupon) {
            setMatchingCode(searchParams?.coupon);
            setViewData(finalData);
          } else {
            setMatchingCode("");
            setViewData("");
          }

          setFilteredData(finalData);
          setTotalPages(res.result?.total_pages || 0);
        }
      }
      setPageLoading(false);
    } catch (error) {
      setPageLoading(false);
      console.log(error, "error");
    }
  };

  useEffect(() => {
    loadMoreData();
    targetRef.current.scrollIntoView({
      behavior: "smooth",
    });
  }, [currentPage]);
  const handleGameChange = async (e) => {
    try {
      // fetchGeneralData();
      winningCouponRef.current.value = "";
      setPageLoading(true);
      setFilteredData([]);
      setListData([]);
      setCurrentPage(1);
      setTotalPages(1);
      const { name, value } = e.target;
      const data = JSON.parse(value);
      const isAllow = await authcheck(data?.draw_time);
      if (isAllow === false) {
        setIsAnalyseAllow(false);
        alert("Access denied! Please come on time.");
      } else {
        setIsAnalyseAllow(true);
        setSelectedCampaign(data || {});

        const prizeOption = {
          type: "single",
          condition: { product_id: parseInt(data?.products_id), status: "A" },
          sort: { _id: -1 },
        };
        const prizeRes = await prizeList(prizeOption);

        if (prizeRes.status === true) {
          setPrizeData(prizeRes.result);
          // alert('prize updated')
        }
        setParams((prev) => ({
          ...prev,
          [name]: parseInt(data?.products_id),
          lotto_type: parseInt(data?.lotto_type) || 0,
        }));

        if (
          data?.straight_settings_default_check === "Unchecked" &&
          data?.rumble_settings_default_check === "Checked" &&
          data?.reverse_settings_default_check === "Unchecked"
        ) {
          setParams((prev) => ({
            ...prev,
            type: "rumble_mix",
            type_ana: "rumble",
          }));
        } else {
          setParams((prev) => ({
            ...prev,
            type: "reverse",
            type_ana: "chance",
            straight: true,
            rumble: true,
          }));
        }
      }

      // if(
      //   parseInt(data?.lotto_type) === 6 ||
      //   parseInt(data?.lotto_type) === 7
      // ){
      //   setParams((prev) => ({
      //     ...prev,
      //     type : 'rumble_mix',
      //     type_ana : 'rumble'
      //   }));
      // } else{
      //   setParams((prev) => ({
      //     ...prev,
      //     type : 'reverse',
      //     type_ana : 'chance',
      //     straight : true,
      //     rumble : true
      //   }));
      // }

      setPageLoading(false);
    } catch (error) {
      setPageLoading(false);
      setFilteredData([]);
      setListData([]);
    } finally {
      handleResetFilter();
    }
  };

  const getExportData = async (page = 1) => {
    try {
      setExportLoading(true);
      const option = {
        ...searchParams,
        page: page,
        limit: 5000,
      };

      const res = await analyzeWinnersList(option);

      if (res.status === true) {
        const finalData = res.result?.finaldata || [];
        // console.log('finalData : ',finalData);
        setExportData((pre) => [...pre, ...finalData]);
        // console.log(`${page} < ${res.result?.total_pages}`)
        if (page < res.result?.total_pages) {
          getExportData(page + 1); // call with next page directly
          setExportLoadingText(
            `Preparing ~ ${(page + 1) * 5000}/${res.result?.total_data || 0} data, please wait...`,
          );
        } else {
          handleExportData();
        }
      }
      // setExportLoading(false);
    } catch (error) {
      setExportLoading(false);
      console.log("Error while fetching export data:", error);
    }
  };

  const handleExportData = async () => {
    try {
      setExportLoadingText("Preparing data, please wait...");
      setExportLoading(false);
      setDetailsLoading(true);
      // let page = exportCurrentPage;
      // let totalPage = exportTotalPage;
      if (EXPORTDATA && EXPORTDATA.length > 0) {
        const { price } = searchParams;

        const modifiedData = EXPORTDATA.map((items, index) => {
          let totalCount = 0;

          return {
            "Sl. No.": index + 1,
            "Match Coupon": items?.ticket?.join(",") || "",
            // "Area": items?.area|| "",

            ...(parseInt(PARAMS?.lotto_type) >= 3 &&
            parseInt(PARAMS?.lotto_type) <= 5
              ? {
                  "Straight Price":
                    parseFloat(items?.straight || 0) *
                    parseFloat(price?.straight || 0),
                  "Straight Count": items?.straight,
                  "Rumble Price":
                    parseFloat(items?.rumble || 0) *
                    parseFloat(price?.rumble || 0),
                  "Rumble Count": items?.rumble,
                }
              : {}),

            ...(PARAMS?.lotto_type
              ? Object.assign(
                  {},
                  ...Array.from({ length: PARAMS.lotto_type }, (_, i) => {
                    const matchIndex = PARAMS.lotto_type - i;
                    if (PARAMS?.lotto_type > 6 && matchIndex < 3) return null;

                    totalCount +=
                      parseInt(items[`match${matchIndex}`], 10) || 0;

                    return {
                      [`${matchIndex} ${PARAMS?.type} Win Amt.`]:
                        parseFloat(items[`match${matchIndex}`] || 0) *
                        parseFloat(price[`match${matchIndex}`] || 0),
                      [`${matchIndex} ${PARAMS?.type} Win Count`]:
                        items[`match${matchIndex}`],
                    };
                  }).filter(Boolean),
                )
              : {}),

            "Total Count": totalCount || 0,
            "Total Amt.": items?.total_amount || 0,
          };
        });
        const workbook = XLSX.utils.book_new();
        const worksheet1 = XLSX.utils.json_to_sheet(modifiedData);

        XLSX.utils.book_append_sheet(workbook, worksheet1, "Matching Winners");
        XLSX.writeFile(
          workbook,
          `Winner's List ${moment().format("YYYY-MM-DD")}.xlsx`,
        );
        setExportLoading(false);
      }
      setDetailsLoading(false);
    } catch (error) {
      setDetailsLoading(false);
      console.log("error : ", error);
    } finally {
      setDetailsLoading(false);
    }
  };

  const handleViewUsers = async (data = {}, type = "") => {
    setDetailsLoading(true);
    try {
      if (data && type) {
        let finaldata = [];
        const option = {
          ...searchParams,
          coupon: data?.ticket?.join(","),
          user_details: true,
        };
        if (option?.coupon === matchingCode) {
          finaldata = viewData;
        } else {
          setMatchingCode(option?.coupon);
          const res = await analizeWinners(option);
          // console.log("res : ", res);
          // console.log("res?.result?.finaldata[0].total_ticket: ", res?.result?.finaldata[0].total_ticket);
          if (res?.status === true) {
            setViewData(res?.result?.finaldata || []);
            finaldata = res?.result?.finaldata || [];
            setOtherData((pre) => ({
              ...pre,
              draw_date : searchParams?.draw_date,
              total_ticket: res?.result?.finaldata[0].total_ticket,
              total_sales:
                res?.result?.finaldata[0].total_ticket *
                selectedCampaign?.straight_add_on_amount,
            }));
          }
        }

        if (finaldata?.length > 0) {
          setDetailsLoading(false);
          if (
            type === "straight" &&
            finaldata?.length > 0 &&
            finaldata[0]?.straight_user?.length > 0
          ) {
            setUsersDetails(finaldata[0]?.straight_user);
          } else if (
            type === "rumble" &&
            finaldata?.length > 0 &&
            finaldata[0]?.rumble_user?.length > 0
          ) {
            // console.log('rumble,...... : ',finaldata[0]?.rumble_user?.length);
            setUsersDetails(finaldata[0]?.rumble_user);
          } else if (
            type === "rumble_super_ball" &&
            finaldata?.length > 0 &&
            finaldata[0]?.rumble_super_ball_user?.length > 0
          ) {
            setUsersDetails(finaldata[0]?.rumble_super_ball_user);
          } else if (
            type === "straight_super_ball" &&
            finaldata?.length > 0 &&
            finaldata[0]?.straight_super_ball_user?.length > 0
          ) {
            setUsersDetails(finaldata[0]?.straight_super_ball_user);
          } else if (
            type === "chance_super_ball" &&
            finaldata?.length > 0 &&
            finaldata[0]?.chance_super_ball_user?.length > 0
          ) {
            setUsersDetails(finaldata[0]?.chance_super_ball_user);
          } else if (type === "all") {
            const rumble = await getWinnersList(finaldata, "rumble");
            const straight = await getWinnersList(finaldata, "straight");
            const match1 = await getWinnersList(finaldata, "match1");
            const match2 = await getWinnersList(finaldata, "match2");
            const match3 = await getWinnersList(finaldata, "match3");
            const match4 = await getWinnersList(finaldata, "match4");
            const match5 = await getWinnersList(finaldata, "match5");
            const match6 = await getWinnersList(finaldata, "match6");
            const match7 = await getWinnersList(finaldata, "match7");

            const straight_super_ball = await getWinnersList(
              finaldata,
              "straight_super_ball",
            );
            const rumble_super_ball = await getWinnersList(
              finaldata,
              "rumble_super_ball",
            );
            const chance_super_ball = await getWinnersList(
              finaldata,
              "chance_super_ball",
            );
            const allData = [
              ...rumble,
              ...straight,
              ...match1,
              ...match2,
              ...match3,
              ...match4,
              ...match5,
              ...match6,
              ...match7,
              ...rumble_super_ball,
              ...straight_super_ball,
              ...chance_super_ball,
            ];
            
            allData.sort((a, b) => b["WINNING AMOUNT"] - a["WINNING AMOUNT"]);
            setFinalData(allData || []);
          } else {
            setUsersDetails(finaldata[0]?.[`${type}_user`]);
          }
        } else {
          setDetailsLoading(false);
          alert("User not found");
        }
      }
    } catch (error) {
      setDetailsLoading(false);
      console.log("error : ", error);
    }
  };

  const getWinnersList = async (data, type) => {
    try {
      // console.log(`${type}_user :`, data[0]);
      if (data?.length > 0) {
        const result = Promise.all(
          data[0][`${type}_user`].map(async (item, index) => {
            // const matchCount = item?.user_matches?.split(',');
            return {
              "Sl.No": index + 1,
              "TICKET ID": item?.order_no || item?.order_id,
              "SELLER FIRST NAME": item?.store_name || "N/A",
              "SELLER LAST NAME": item?.area || "N/A",
              "SELLER MOBILE": item?.seller_mobile,
              "COUPONS" : item?.ticket?.join(","),

              "STRAIGHT AMOUNT": item?.ticket_type === "Straight" ? 1 : 0,
              "RUMBLE AMOUNT": item?.ticket_type === "Rumble" ? 1 : 0,
              "CHANCE AMOUNT": item?.ticket_type === "Chance" ? 1 : 0,

              ...(type === "straight" && {
                "WINNER TYPE": "Straight Prize",
                "WINNING AMOUNT":
                  parseFloat(data[0][`straight_price`]) /
                  parseFloat(data[0][`${type}`]),
              }),
              ...(type === "straight_super_ball" && {
                "WINNER TYPE": "Straight Super Ball Prize",
                "WINNING AMOUNT":
                  parseFloat(data[0][`straight_super_ball_price`]) /
                  parseFloat(data[0][`${type}`]),
              }),
              ...(type === "rumble_super_ball" && {
                "WINNER TYPE": "Rumble Super Ball Prize",
                "WINNING AMOUNT":
                  parseFloat(data[0][`rumble_super_ball_price`]) /
                  parseFloat(data[0][`${type}`]),
              }),
              ...(type === "rumble" && {
                "WINNER TYPE": "Rumble Prize",
                "WINNING AMOUNT":
                  parseFloat(data[0][`rumble_price`]) /
                  parseFloat(data[0][`${type}`]),
              }),
              ...(type === "match1" && {
                ...(item?.ticket_type === "Chance"
                  ? {
                      "WINNER TYPE": `${item?.ticket_type} Prize`,
                    }
                  : {
                      "WINNER TYPE": `1 Match Prize`,
                    }),
                "WINNING AMOUNT":
                  parseFloat(data[0][`${type}_price`]) /
                  parseFloat(data[0][`${type}`]),
              }),
              ...(type === "match2" && {
                ...(item?.ticket_type === "Chance"
                  ? {
                      "WINNER TYPE": `${item?.ticket_type} Prize`,
                    }
                  : {
                      "WINNER TYPE": `2 Match Prize`,
                    }),
                "WINNING AMOUNT":
                  parseFloat(data[0][`${type}_price`]) /
                  parseFloat(data[0][`${type}`]),
              }),
              ...(type === "match3" && {
                ...(item?.ticket_type === "Chance"
                  ? {
                      "WINNER TYPE": `${item?.ticket_type} Prize`,
                    }
                  : {
                      "WINNER TYPE": `3 Match Prize`,
                    }),
                "WINNING AMOUNT":
                  parseFloat(data[0][`${type}_price`]) /
                  parseFloat(data[0][`${type}`]),
              }),
              ...(type === "match4" && {
                ...(item?.ticket_type === "Chance"
                  ? {
                      "WINNER TYPE": `${item?.ticket_type} Prize`,
                    }
                  : {
                      "WINNER TYPE": `4 Match Prize`,
                    }),
                "WINNING AMOUNT":
                  parseFloat(data[0][`${type}_price`]) /
                  parseFloat(data[0][`${type}`]),
              }),
              ...(type === "match5" && {
                ...(item?.ticket_type === "Chance"
                  ? {
                      "WINNER TYPE": `${item?.ticket_type} Prize`,
                    }
                  : {
                      "WINNER TYPE": `5 Match Prize`,
                    }),
                "WINNING AMOUNT":
                  parseFloat(data[0][`${type}_price`]) /
                  parseFloat(data[0][`${type}`]),
              }),
              ...(type === "match6" && {
                ...(item?.ticket_type === "Chance"
                  ? {
                      "WINNER TYPE": `${item?.ticket_type} Prize`,
                    }
                  : {
                      "WINNER TYPE": `6 Match Prize`,
                    }),
                "WINNING AMOUNT":
                  parseFloat(data[0][`${type}_price`]) /
                  parseFloat(data[0][`${type}`]),
              }),
              ...(type === "match7" && {
                ...(item?.ticket_type === "Chance"
                  ? {
                      "WINNER TYPE": `${item?.ticket_type} Prize`,
                    }
                  : {
                      "WINNER TYPE": `7 Match Prize`,
                    }),
                "WINNING AMOUNT":
                  parseFloat(data[0][`${type}_price`]) /
                  parseFloat(data[0][`${type}`]),
              }),

              ...(type === "chance_super_ball" && {
                "WINNER TYPE": `Chance Super Ball Prize`,
                "WINNING AMOUNT":
                  parseFloat(data[0][`${type}_price`]) /
                  parseFloat(data[0][`${type}`]),
              }),

              ...(((item?.ticket_type === "Chance" || item?.ticket_type === "chance") && selectedCampaign?.super_ball_mode === "Y")
                ? {
                    "MATCHING NUMBER": String(item?.user_matches ?? "")
                      .split("")
                      .reverse()
                      .join(""),
                  }
                : {
                    "MATCHING NUMBER": item?.user_matches,
                  }),
            };
          }),
        );
        return result;
      } else {
        return [];
      }
    } catch (error) {}
  };

  const handleSort = () => {
    try {
      const value = sortConfig === "asc" ? "desc" : "asc";
      setSortConfig(value);
    } catch (error) {
      console.log("error:", error);
    }
  };
  const straightSuperBallRef = useRef(null);
  const straightSuperBallRef_Select = useRef(null);
  const straightNumberRef = useRef(null);
  const straightNumberRef_Select = useRef(null);
  const rumbleSuperBallRef = useRef(null);
  const rumbleSuperBallRef_Select = useRef(null);
  const rumbleNumberRef = useRef(null);
  const rumbleNumberRef_Select = useRef(null);
  const chanceSuperBallRef = useRef(null);
  const chanceSuperBallRef_Select = useRef(null);
  const matchRefs = useRef({});
  const matchRefs_Select = useRef({});

  const handleMatchChange = (e) => {
    try {
      const { name, value } = e.target;
      if (name === "filter_straight") {
        straightNumberRef.current.value = "";
      } else if (name === "filter_rumble") {
        rumbleNumberRef.current.value = "";
      } else if (name === "filter_straight_super_ball") {
        straightSuperBallRef.current.value = "";
      } else if (name === "filter_rumble_super_ball") {
        rumbleSuperBallRef.current.value = "";
      } else if (name === "filter_chance_super_ball") {
        chanceSuperBallRef.current.value = "";
      } else if (name === "sort_order") {
        setSortConfig(value);
      } else if (name === "amount") {
        setAmount(value);
      } else {
        matchRefs.current[`${name}_number`].value = "";
      }
    } catch (error) {}
  };

  const authcheck = async (draw) => {
    try {
      const adminInfo =
        (await fetchAdminProfile()) ||
        JSON.parse(sessionStorage.getItem("ADMIN-INFO") || "{}");
      const enableRestriction = adminInfo?.draw_time_restriction || "N";
      setEnableDrawTimeRestriction(enableRestriction);
      const drawArray = {
        "22:00": "draw_one",

        "23:00": "draw_two",
        "23:30": "draw_two",

        "21:00": "draw_three",
        "21:30": "draw_three",

        "23:59": "draw_four",
      };
      if (adminInfo?.admin_type === "Super Admin") return true;

      const drawKey = drawArray[`${draw}`];
      
      if (!drawKey || adminInfo?.[drawKey] !== "Y") return false;
      if (enableRestriction !== "Y") {
        return true;
      }

      const startTime = adminInfo?.[`${drawKey}_start_time`];
      const endTime = adminInfo?.[`${drawKey}_end_time`];
      
      if (!startTime || !endTime) return false;      
      const cH = parseInt(moment().format("HH"));
      const cM = parseInt(moment().format("mm"));
      
      const [sH, sM] = startTime.split(":").map(Number);
      const [eH, eM] = endTime.split(":").map(Number);
      let analyserAccessStart = moment().hour(sH).minute(sM).second(0).millisecond(0);
      let analyserAccessEnd = moment().hour(eH).minute(eM).second(0).millisecond(0);

      if((sH > eH) || (sH === eH && sM > eM)){
        analyserAccessEnd = analyserAccessEnd.add(1, "day");
      }
      if((cH < sH) || (cM < sM)){
        analyserAccessStart = analyserAccessStart.subtract(1, "day");
        analyserAccessEnd = analyserAccessEnd.subtract(1, "day");
      }

      if (analyserAccessStart.isBefore(moment()) && analyserAccessEnd.isAfter(moment())) {
        return true;
      }
      return false;
    } catch (error) {
      console.log("error : ", error);
      return false;
    }
  };

  const handleResetFilter = () => {
    try {
      if (straightNumberRef.current?.value)
        straightNumberRef.current.value = "";
      if (straightNumberRef_Select.current?.value)
        straightNumberRef_Select.current.value = "";
      if (rumbleNumberRef.current?.value) rumbleNumberRef.current.value = "";
      if (rumbleNumberRef_Select.current?.value)
        rumbleNumberRef_Select.current.value = "";
      if (straightSuperBallRef.current?.value)
        straightSuperBallRef.current.value = "";
      if (straightSuperBallRef_Select.current?.value)
        straightSuperBallRef_Select.current.value = "";
      if (rumbleSuperBallRef.current?.value)
        rumbleSuperBallRef.current.value = "";
      if (rumbleSuperBallRef_Select.current?.value)
        rumbleSuperBallRef_Select.current.value = "";
      if (chanceSuperBallRef.current?.value)
        chanceSuperBallRef.current.value = "";
      if (chanceSuperBallRef_Select.current?.value)
        chanceSuperBallRef_Select.current.value = "";
      if (matchRefs.current[`match7_number`]?.value)
        matchRefs.current[`match7_number`].value = "";
      if (matchRefs.current[`match6_number`]?.value)
        matchRefs.current[`match6_number`].value = "";
      if (matchRefs.current[`match5_number`]?.value)
        matchRefs.current[`match5_number`].value = "";
      if (matchRefs.current[`match4_number`]?.value)
        matchRefs.current[`match4_number`].value = "";
      if (matchRefs.current[`match3_number`]?.value)
        matchRefs.current[`match3_number`].value = "";
      if (matchRefs.current[`match2_number`]?.value)
        matchRefs.current[`match2_number`].value = "";

      if (matchRefs_Select.current[`match7`])
        matchRefs_Select.current[`match7`].selectedIndex = 0;
      if (matchRefs_Select.current[`match6`])
        matchRefs_Select.current[`match6`].selectedIndex = 0;
      if (matchRefs_Select.current[`match5`])
        matchRefs_Select.current[`match5`].selectedIndex = 0;
      if (matchRefs_Select.current[`match4`])
        matchRefs_Select.current[`match4`].selectedIndex = 0;
      if (matchRefs_Select.current[`match3`])
        matchRefs_Select.current[`match3`].selectedIndex = 0;
      if (matchRefs_Select.current[`match2`])
        matchRefs_Select.current[`match2`].selectedIndex = 0;
      setAmount("");
    } catch (error) {
      console.log("error : ", error);
    }
  };

  return (
    <>
      <div className="container-fluid" ref={targetRef}>
        <TobNavBar title={"Analyse winner"}></TobNavBar>
        <div className="inventory_tabs_main_div">
          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <form onSubmit={analyzeWinnerData}>
                <div className="row inventory_all_tabs">
                  <div className="form-group row">
                    <div className="row background_one">
                      <div className="form-group col-lg-4 col-md-4 col-sm-6 col-xs-12 ">
                        <label
                          htmlFor="campaign"
                          className="all_section_for_label_main_class"
                          // onClick={() => console.log("otherData : ", otherData)}
                        >
                          <span style={{ color: "red" }}>*</span>Campaign :
                        </label>
                        <select
                          className="form-control store_input_field"
                          id="campaign"
                          name="campaign"
                          onChange={handleGameChange}
                        >
                          <option value={""} selected disabled>
                            Select Campaign
                          </option>
                          {campaignListData?.length > 0 &&
                            campaignListData.map((items, index) => (
                              <option
                                key={index}
                                value={JSON.stringify(items)}
                                selected={
                                  PARAMS?.campaign === items?.products_id
                                    ? true
                                    : false
                                }
                              >
                                {items?.title}
                              </option>
                            ))}
                        </select>
                      </div>
                      <div className="form-group col-lg-4 col-md-4 col-sm-6 col-xs-12 ">
                        <label
                          htmlFor="draw_date"
                          className="all_section_for_label_main_class"
                        >
                          <span style={{ color: "red" }}>*</span>Draw Date
                          :{" "}
                        </label>
                        <input
                          type="date"
                          className="form-control store_input_field"
                          onChange={handleChange}
                          name="draw_date"
                          id="draw_date"
                        />
                      </div>

                      <div className="form-group col-lg-4 col-md-4 col-sm-6 col-xs-12 ">
                        <label
                          htmlFor="suggestions_count"
                          className="all_section_for_label_main_class"
                          onClick={() => {
                            console.log(PARAMS);
                            console.log("prizedata :", PRIZEDATA);
                          }}
                        >
                          Winning Coupon :
                        </label>
                        <input
                          type="text"
                          className="form-control store_input_field"
                          onChange={handleChange}
                          ref={winningCouponRef}
                          name="coupon"
                          id="coupon"
                        />
                      </div>
                    </div>

                    <div className="row mt-2 background_one">
                      {(parseInt(PARAMS?.lotto_type) === 5 ||
                        parseInt(PARAMS?.lotto_type) === 4 ||
                        parseInt(PARAMS?.lotto_type) === 3) && (
                        <>
                          {PRIZEDATA["straight_super_prize"] &&
                            parseFloat(PRIZEDATA["straight_super_prize"]) > 0 &&
                            selectedCampaign?.enable_super_ball === "Y" && (
                              <div className="form-group col-lg-2 col-md-2 col-sm-3 col-xs-12 ">
                                <label
                                  htmlFor="straight_super_ball"
                                  className="all_section_for_label_main_class"
                                >
                                  Straight Super Prize :
                                </label>
                                <input
                                  type="number"
                                  value={PRIZEDATA[`straight_super_prize`]}
                                  className="form-control store_input_field"
                                  onChange={handleChange}
                                  name="straight_super_ball"
                                  id="straight_super_ball"
                                />
                              </div>
                            )}
                          {(selectedCampaign?.straight_settings_default_check ===
                            "Checked" ||
                            PARAMS?.straight === true) &&
                            PRIZEDATA[`stright_prize${PARAMS?.lotto_type}`] >
                              0 && (
                              <div className="form-group col-lg-2 col-md-2 col-sm-3 col-xs-12 ">
                                <label
                                  htmlFor="suggestions_count"
                                  className="all_section_for_label_main_class"
                                >
                                  Straight :
                                </label>
                                <input
                                  type="number"
                                  value={
                                    PRIZEDATA[
                                      `stright_prize${PARAMS?.lotto_type}`
                                    ]
                                  }
                                  className="form-control store_input_field"
                                  onChange={handleChange}
                                  name="stright_prize"
                                  id="stright_prize"
                                />
                              </div>
                            )}

                          {PRIZEDATA["rumble_super_prize"] &&
                            PRIZEDATA["rumble_super_prize"] > 0 &&
                            selectedCampaign?.enable_super_ball === "Y" && (
                              <div className="form-group col-lg-2 col-md-2 col-sm-3 col-xs-12 ">
                                <label
                                  htmlFor="rumble_super_ball"
                                  className="all_section_for_label_main_class"
                                >
                                  Rumble Super Prize :
                                </label>
                                <input
                                  type="number"
                                  value={PRIZEDATA[`rumble_super_prize`]}
                                  className="form-control store_input_field"
                                  onChange={handleChange}
                                  name="rumble_super_ball"
                                  id="rumble_super_ball"
                                />
                              </div>
                            )}
                          {(selectedCampaign?.rumble_settings_default_check ===
                            "Checked" ||
                            PARAMS?.rumble === true) && (
                            <div className="form-group col-lg-2 col-md-2 col-sm-3 col-xs-12 ">
                              <label
                                htmlFor="rumble_mix_prize"
                                className="all_section_for_label_main_class"
                              >
                                Rumble :
                              </label>
                              <input
                                type="number"
                                value={
                                  PRIZEDATA[
                                    `rumble_mix_prize${PARAMS?.lotto_type}`
                                  ]
                                }
                                className="form-control store_input_field"
                                onChange={handleChange}
                                name="rumble_mix_prize"
                                id="rumble_mix_prize"
                              />
                            </div>
                          )}
                        </>
                      )}
                      {selectedCampaign?.enable_super_ball === "Y" && (
                        <div className="form-group col-lg-2 col-md-2 col-sm-3 col-xs-12">
                          <label
                            htmlFor={`chance_super_ball`}
                            className="all_section_for_label_main_class"
                          >
                            Chance Super Prize
                          </label>
                          <input
                            type="number"
                            className="form-control store_input_field"
                            onChange={handleChange}
                            value={PRIZEDATA[`chance_super_prize`]}
                            // value={PRIZEDATA[`reverse_prize${index}`]}
                            name={`chance_super_ball`}
                            id={`chance_super_ball`}
                          />
                        </div>
                      )}
                      {PARAMS?.lotto_type
                        ? Array.from(
                            { length: PARAMS?.lotto_type },
                            (_, i) => PARAMS?.lotto_type - i,
                          ).map((index) =>
                            PRIZEDATA[`${PARAMS?.type}_prize${index}`] ===
                            0 ? null : (
                              <div
                                key={index}
                                className="form-group col-lg-2 col-md-2 col-sm-3 col-xs-12"
                              >
                                <label
                                  onClick={() => console.log(PARAMS)}
                                  htmlFor={`reverse_${index}`}
                                  className="all_section_for_label_main_class"
                                >
                                  Match {index} :
                                </label>
                                <input
                                  type="number"
                                  className="form-control store_input_field"
                                  onChange={handleChange}
                                  value={
                                    PRIZEDATA[`${PARAMS?.type}_prize${index}`]
                                  }
                                  // value={PRIZEDATA[`reverse_prize${index}`]}
                                  name={`reverse_${index}`}
                                  id={`reverse_${index}`}
                                />
                              </div>
                            ),
                          )
                        : null}
                    </div>
                    {/* Filter Section */}
                    <div className="row mt-2 background_one">
                      {(parseInt(PARAMS?.lotto_type) === 5 ||
                        parseInt(PARAMS?.lotto_type) === 4 ||
                        parseInt(PARAMS?.lotto_type) === 3) && (
                        <>
                          {PRIZEDATA["straight_super_prize"] &&
                            parseFloat(PRIZEDATA["straight_super_prize"]) > 0 &&
                            selectedCampaign?.enable_super_ball === "Y" && (
                              <>
                                <div className="form-group col-lg-2 col-md-2 col-sm-3 col-xs-12 ">
                                  <label
                                    htmlFor="straight_super_ball"
                                    className="all_section_for_label_main_class"
                                  >
                                    Straight Super Prize :
                                  </label>
                                  {/* <input type="number" value={PRIZEDATA[`straight_super_prize`]} className="form-control store_input_field" onChange={handleChange} name="straight_super_ball" id="straight_super_ball" /> */}
                                  <select
                                    name="filter_straight_super_ball"
                                    id="filter_straight_super_ball"
                                    className="form-control store_input_field"
                                    onChange={handleMatchChange}
                                    ref={straightSuperBallRef_Select}
                                  >
                                    <option value={""}>All</option>
                                    <option value={"equal_to"}>Equal to</option>
                                    <option value={"greater_than"}>
                                      Greater than
                                    </option>
                                    <option value={"less_than"}>
                                      Less than
                                    </option>
                                  </select>
                                </div>
                                <div className="form-group col-lg-2 col-md-2 col-sm-3 col-xs-12 ">
                                  <label
                                    htmlFor="straight_super_ball_number"
                                    className="all_section_for_label_main_class"
                                  >
                                    Number
                                  </label>
                                  <input
                                    type="number"
                                    className="form-control store_input_field"
                                    ref={straightSuperBallRef}
                                    name="straight_super_ball_number"
                                    id="straight_super_ball_number"
                                  />
                                </div>
                              </>
                            )}
                          {(selectedCampaign?.straight_settings_default_check ===
                            "Checked" ||
                            PARAMS?.straight === true) &&
                            PRIZEDATA[`stright_prize${PARAMS?.lotto_type}`] >
                              0 && (
                              <>
                                <div className="form-group col-lg-2 col-md-2 col-sm-3 col-xs-12 ">
                                  <label
                                    htmlFor="filter_straight"
                                    className="all_section_for_label_main_class"
                                  >
                                    Straight Winner :
                                  </label>
                                  <select
                                    name="filter_straight"
                                    className="form-control store_input_field"
                                    onChange={handleMatchChange}
                                    ref={straightNumberRef_Select}
                                  >
                                    <option value={""}>All</option>
                                    <option value={"equal_to"}>Equal to</option>
                                    <option value={"greater_than"}>
                                      Greater than
                                    </option>
                                    <option value={"less_than"}>
                                      Less than
                                    </option>
                                  </select>
                                </div>
                                <div className="form-group col-lg-2 col-md-2 col-sm-3 col-xs-12 ">
                                  <label
                                    htmlFor="straight_number"
                                    className="all_section_for_label_main_class"
                                  >
                                    Number
                                  </label>
                                  <input
                                    type="number"
                                    className="form-control store_input_field"
                                    ref={straightNumberRef}
                                    name="straight_number"
                                    id="straight_number"
                                  />
                                </div>
                              </>
                            )}

                          {PRIZEDATA["rumble_super_prize"] &&
                            PRIZEDATA["rumble_super_prize"] > 0 &&
                            selectedCampaign?.enable_super_ball === "Y" && (
                              <>
                                <div className="form-group col-lg-2 col-md-2 col-sm-3 col-xs-12 ">
                                  <label
                                    htmlFor="rumble_super_ball"
                                    className="all_section_for_label_main_class"
                                  >
                                    Rumble Super Prize :
                                  </label>
                                  {/* <input type="number" value={PRIZEDATA[`rumble_super_prize`]} className="form-control store_input_field" onChange={handleChange} name="rumble_super_ball" id="rumble_super_ball" /> */}
                                  <select
                                    name="filter_rumble_super_ball"
                                    className="form-control store_input_field"
                                    onChange={handleMatchChange}
                                    ref={rumbleSuperBallRef_Select}
                                  >
                                    <option value={""}>All</option>
                                    <option value={"equal_to"}>Equal to</option>
                                    <option value={"greater_than"}>
                                      Greater than
                                    </option>
                                    <option value={"less_than"}>
                                      Less than
                                    </option>
                                  </select>
                                </div>
                                <div className="form-group col-lg-2 col-md-2 col-sm-3 col-xs-12 ">
                                  <label
                                    htmlFor="rumble_super_ball_number"
                                    className="all_section_for_label_main_class"
                                  >
                                    Number
                                  </label>
                                  <input
                                    type="number"
                                    className="form-control store_input_field"
                                    ref={rumbleSuperBallRef}
                                    name="rumble_super_ball_number"
                                    id="rumble_super_ball_number"
                                  />
                                </div>
                              </>
                            )}
                          {(selectedCampaign?.rumble_settings_default_check ===
                            "Checked" ||
                            PARAMS?.rumble === true) && (
                            <>
                              <div className="form-group col-lg-2 col-md-2 col-sm-3 col-xs-12 ">
                                <label
                                  htmlFor="filter_rumble"
                                  className="all_section_for_label_main_class"
                                >
                                  Rumble Winner:
                                </label>
                                <select
                                  name="filter_rumble"
                                  className="form-control store_input_field"
                                  onChange={handleMatchChange}
                                  ref={rumbleNumberRef_Select}
                                >
                                  <option value={""}>All</option>
                                  <option value={"equal_to"}>Equal to</option>
                                  <option value={"greater_than"}>
                                    Greater than
                                  </option>
                                  <option value={"less_than"}>Less than</option>
                                </select>
                              </div>
                              <div className="form-group col-lg-2 col-md-2 col-sm-3 col-xs-12 ">
                                <label
                                  htmlFor="rumble_number"
                                  className="all_section_for_label_main_class"
                                >
                                  Number:
                                </label>
                                <input
                                  type="number"
                                  className="form-control store_input_field"
                                  ref={rumbleNumberRef}
                                  name="rumble_number"
                                  id="rumble_number"
                                />
                              </div>
                            </>
                          )}
                        </>
                      )}

                      {selectedCampaign?.enable_super_ball === "Y" && (
                        <>
                          <div className="form-group col-lg-2 col-md-2 col-sm-3 col-xs-12">
                            <label
                              htmlFor={`filter_chance_super_ball`}
                              className="all_section_for_label_main_class"
                            >
                              Chance Super Prize
                            </label>
                            <select
                              name="filter_chance_super_ball"
                              className="form-control store_input_field"
                              onChange={handleMatchChange}
                              ref={chanceSuperBallRef_Select}
                            >
                              <option value={""}>All</option>
                              <option value={"equal_to"}>Equal to</option>
                              <option value={"greater_than"}>
                                Greater than
                              </option>
                              <option value={"less_than"}>Less than</option>
                            </select>
                          </div>
                          <div className="form-group col-lg-2 col-md-2 col-sm-3 col-xs-12 ">
                            <label
                              htmlFor="rumble_number"
                              className="all_section_for_label_main_class"
                            >
                              Number:
                            </label>
                            <input
                              type="number"
                              className="form-control store_input_field"
                              ref={chanceSuperBallRef}
                              name="chance_super_ball_number"
                              id="chance_super_ball_number"
                            />
                          </div>
                        </>
                      )}
                      {PARAMS?.lotto_type
                        ? Array.from(
                            { length: PARAMS?.lotto_type },
                            (_, i) => PARAMS?.lotto_type - i,
                          ).map((index) =>
                            // ((PARAMS?.lotto_type >= 5 && index < 3) || (PARAMS?.lotto_type < 6 && index > 2)) ? (<>
                            // (PARAMS?.lotto_type === 5 && index < 3) ||
                            // (PARAMS?.lotto_type === 5 && PARAMS?.type === "rumble_mix" && index < 2 && PRIZEDATA[`${PARAMS?.type}_prize${index}`] > 0) ||
                            // (PARAMS?.lotto_type === 6 && index < 3) ||
                            // (PARAMS?.lotto_type === 7 && index < 3)
                            PRIZEDATA[`${PARAMS?.type}_prize${index}`] ===
                            0 ? null : (
                              <>
                                <div className="form-group col-lg-2 col-md-2 col-sm-3 col-xs-12">
                                  <label
                                    htmlFor={`match${index}`}
                                    className="all_section_for_label_main_class"
                                  >
                                    {`${PARAMS?.type_ana}`} {index} winner
                                  </label>
                                  <select
                                    name={`match${index}`}
                                    className="form-control store_input_field"
                                    onChange={handleMatchChange}
                                    ref={(el) =>
                                      (matchRefs_Select.current[
                                        `match${index}`
                                      ] = el)
                                    }
                                  >
                                    <option value={""}>All</option>
                                    <option value={"equal_to"}>Equal to</option>
                                    <option value={"greater_than"}>
                                      Greater than
                                    </option>
                                    <option value={"less_than"}>
                                      Less than
                                    </option>
                                  </select>
                                </div>

                                <div className="form-group col-lg-2 col-md-2 col-sm-3 col-xs-12">
                                  <label
                                    htmlFor={`match${index}_number`}
                                    className="all_section_for_label_main_class"
                                  >
                                    {`${PARAMS?.type_ana}`} {index} : number
                                  </label>
                                  <input
                                    type="number"
                                    className="form-control store_input_field"
                                    ref={(el) =>
                                      (matchRefs.current[
                                        `match${index}_number`
                                      ] = el)
                                    }
                                    name={`match${index}_number`}
                                    id={`match${index}_number`}
                                  />
                                </div>
                              </>
                            ),
                          )
                        : null}

                      {/* {(parseInt(PARAMS?.lotto_type) === 6 && parseInt(selectedCampaign?.lotto_range_start) === 1 && parseInt(selectedCampaign?.lotto_range_end) === 27) ? (<>
                          <div className="form-group col-lg-2 col-md-2 col-sm-3 col-xs-12">
                            <label htmlFor={`match2`} className="all_section_for_label_main_class">
                              Chance 2 winner
                            </label>
                            <select name={`match2`} className="form-control store_input_field" onChange={handleMatchChange} ref={el => matchRefs_Select.current[`match2`] = el}>
                              <option value={''}>All</option>
                              <option value={'equal_to'} >Equal to</option>
                              <option value={'greater_than'} >Greater than</option>
                              <option value={'less_than'} >Less than</option>
                            </select>
                          </div>

                          <div className="form-group col-lg-2 col-md-2 col-sm-3 col-xs-12">
                            <label htmlFor={`match2_number`} className="all_section_for_label_main_class">
                              Chance 2 : number
                            </label>
                            <input 
                              type="number" 
                              className="form-control store_input_field" 
                              ref={(el) => matchRefs.current[`match2_number`] = el}
                              name={`match2_number`} 
                              id={`match2_number`} 
                            />
                          </div>
                        </>):(<></>)} */}

                      <div className="form-group col-lg-2 col-md-2 col-sm-3 col-xs-12 ">
                        <label
                          htmlFor="straight_super_ball"
                          className="all_section_for_label_main_class"
                        >
                          Sort Order :
                        </label>
                        {/* <input type="number" value={PRIZEDATA[`straight_super_prize`]} className="form-control store_input_field" onChange={handleChange} name="straight_super_ball" id="straight_super_ball" /> */}
                        <select
                          name="sort_order"
                          id="sort_order"
                          className="form-control store_input_field"
                          onChange={handleMatchChange}
                        >
                          <option value={"asc"} selected={sortConfig === "asc"}>
                            Largest
                          </option>
                          <option
                            value={"desc"}
                            selected={sortConfig === "desc"}
                          >
                            Smallest
                          </option>
                        </select>
                      </div>

                      <div className="form-group col-lg-2 col-md-2 col-sm-3 col-xs-12 ">
                        <label
                          htmlFor="straight_super_ball"
                          className="all_section_for_label_main_class"
                        >
                          Max. Winning Amt. :
                        </label>
                        <input
                          type="number"
                          value={amount}
                          className="form-control store_input_field"
                          onChange={handleMatchChange}
                          name="amount"
                          id="amount"
                          placeholder="Approx. winning amount."
                        />
                      </div>
                    </div>
                    <div className="row mt-2 background_one">
                      {(parseInt(PARAMS?.lotto_type) === 5 ||
                        parseInt(PARAMS?.lotto_type) === 4 ||
                        parseInt(PARAMS?.lotto_type) === 3) && (
                        (
                          selectedCampaign?.straight_settings_default_check ==="Checked" || 
                          PARAMS?.straight === true) && 
                          PRIZEDATA[`stright_prize${PARAMS?.lotto_type}`] > 0 && (<>
                            <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                              <label
                                htmlFor="straight_super_ball"
                                className="all_section_for_label_main_class"
                              >
                                Straight Win :
                              </label>
                            </div>
                            <div className="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12 ">
                              <UserSelectWithSearch
                                value={selectedStraightUsers}
                                onChange={setSelectedUsers}
                                placeholder="Select Users"
                                userTypes={["Retailer"]}
                                condition={{ status: "A" }}
                                className="form-control store_input_field"
                                style={{ width: "100%" }}
                                maxTagCount={2}
                                showSearch={true}
                                mode="multiple"
                                multiple={true}
                                showSelectAll={true}
                                disableOptions={false}
                              />
                            </div>
                            <div className="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12 ">
                              <AreaMultiSelect
                                value={selectedStraightArea}
                                onChange={setSelectedStraightArea}
                                placeholder="Select Areas"
                                areas={analyserAreas}
                              />
                            </div>

                          </>
                        )
                      )}
                      {(parseInt(PARAMS?.lotto_type) === 5 ||
                        parseInt(PARAMS?.lotto_type) === 4 ||
                        parseInt(PARAMS?.lotto_type) === 3) && 
                        (
                        selectedCampaign?.rumble_settings_default_check === "Checked" ||
                        PARAMS?.rumble === true) && (<>
                          <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                            <label
                              htmlFor="straight_super_ball"
                              className="all_section_for_label_main_class"
                            >
                              Rumble Win :
                            </label>
                          </div>
                          <div className="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12 ">
                            <UserSelectWithSearch
                              value={selectedRumbleUsers}
                              onChange={setSelectedRumbleUsers}
                              placeholder="Select Users"
                              userTypes={["Retailer"]}
                              condition={{ status: "A" }}
                              className="form-control store_input_field"
                              style={{ width: "100%" }}
                              maxTagCount={2}
                              showSearch={true}
                              mode="multiple"
                              multiple={true}
                              showSelectAll={true}
                              disableOptions={false}
                            />

                          </div>
                          <div className="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12 ">
                            <AreaMultiSelect
                              value={selectedRumbleArea}
                              onChange={setSelectedRumbleArea}
                              placeholder="Select Areas"
                              areas={analyserAreas}
                            />

                          </div>
                        </>
                        )}


                        {PARAMS?.lotto_type
                        ? Array.from(
                            { length: PARAMS?.lotto_type },
                            (_, i) => PARAMS?.lotto_type - i,
                          ).map((index) =>
                            (PRIZEDATA[`${PARAMS?.type}_prize${index}`] ===
                            0 || index < 3) ? null : (<React.Fragment key={index}>
                              <div
                                className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12"
                              >
                                <label
                                  onClick={() => console.log(PARAMS)}
                                  htmlFor={`reverse_${index}`}
                                  className="all_section_for_label_main_class"
                                >
                                  Match {index} Win:
                                </label>
                              </div>
                              <div
                                className="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12"
                              >
                                <UserSelectWithSearch
                                  value={selectedMatchUsers[index] || []}
                                  onChange={(selectedUsers) => {
                                    setSelectedMatchUsers((prev) => ({
                                      ...prev,
                                      [index]: selectedUsers,
                                    }));
                                  }}
                                  placeholder="Select Users"
                                  userTypes={["Retailer"]}
                                  condition={{ status: "A" }}
                                  className="form-control store_input_field"
                                  style={{ width: "100%" }}
                                  maxTagCount={2}
                                  showSearch={true}
                                  mode="multiple"
                                  multiple={true}
                                  showSelectAll={true}
                                  disableOptions={false}
                                />
                              </div>
                              <div
                                className="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12"
                              >
                                <AreaMultiSelect
                                  value={selectedMatchArea[index] || []}
                                  onChange={(selectedAreas) => {
                                    setSelectedMatchArea((prev) => ({
                                      ...prev,
                                      [index]: selectedAreas,
                                    }));
                                  }}
                                  placeholder="Select Areas"
                                  areas={analyserAreas}
                                />
                              </div>
                            </React.Fragment>
                            ),
                          )
                        : null}
                    </div>
                    

                    {/* Filter Section End */}
                    {(PERMISSION?.fullAccess === "Y" ||
                      PERMISSION?.list === "Y") && (
                      <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div className="inventory_open_popup_action_btn">
                          <button
                            type="submit"
                            className="btn btn-danger"
                            style={{ width: "20%" }}
                            disabled={isAnalyseAllow === false}
                          >
                            {" "}
                            Analyse{" "}
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </form>
            </Box>

            <VendorList>
              <div>
                <div id="content-wrapper" className="d-flex flex-column">
                  <div className="card shadow mb-4">
                    <div className="card-body pt-0">
                      {orderStatic && parseInt(orderStatic) > 0 && (
                        <div className="row">
                          <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12">
                            <label
                              htmlFor="campaign"
                              className="all_section_for_label_main_class"
                            ></label>
                            <h4>Total Tickets : {orderStatic}</h4>
                          </div>

                          <div className="form-group col-lg-6 col-md-6 col-sm-6 col-xs-12">
                            <label
                              htmlFor="campaign"
                              className="all_section_for_label_main_class"
                            ></label>
                            <h4>Total Sales : {otherData?.total_sales}</h4>
                          </div>

                          {/* <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12">
                            <label htmlFor="campaign" className="all_section_for_label_main_class" ></label>
                            <h4>Cancel Orders : {orderStatic.find(item => item._id === 'CL')?.total_qty || 0}</h4>
                          </div>
                          <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12">
                            <label htmlFor="campaign" className="all_section_for_label_main_class" ></label>
                            <h4>Success Orders : {orderStatic.find(item => item._id === 'A')?.total_qty || 0}</h4>
                          </div> */}
                          {(PERMISSION?.fullAccess === "Y" ||
                            PERMISSION?.export === "Y") && (
                            <div className="form-group col-lg-3 col-md-3 col-sm-12 col-xs-12">
                              {EXPORTDATA && EXPORTDATA?.length > 0 ? (
                                <div className="inventory_open_popup_action_btn">
                                  <button
                                    type="button"
                                    className="btn btn-danger"
                                    onClick={() => handleExportData()}
                                  >
                                    <FontAwesomeIcon icon={faCloudDownload} />{" "}
                                    Download
                                  </button>
                                </div>
                              ) : (
                                <div className="inventory_open_popup_action_btn">
                                  <button
                                    type="button"
                                    className="btn btn-danger"
                                    onClick={() => getExportData(1)}
                                  >
                                    <FontAwesomeIcon icon={faCloudDownload} />{" "}
                                    Export
                                  </button>
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      )}
                      {/* <div className="row">
                          <div className="form-group col-lg-10 col-md-10 col-sm-10 col-xs-12">
                            <input type="test" name="searchValue" id="searchValue" className="form-control store_input_field" onChange={(e)=>setSearchValue(e.target.value)}  placeholder="Search" />
                          </div>
                          <div className="form-group col-lg-2 col-md-2 col-sm-2 col-xs-12">
                            <button type="button" className="btn btn-danger" onClick={()=>handleSort("")} >Search</button>
                          </div>
                        </div> */}
                      <div className="table_pagination_sales_order">
                        <Pagination
                          count={TOTALPAGES || 1}
                          page={currentPage || 1}
                          onChange={handlePageChange}
                        />
                      </div>
                      <div className="table-responsive">
                        <table
                          className="table table-bordered"
                          id="dataTable"
                          width="100%"
                          cellspacing="0"
                        >
                          <thead>
                            <tr>
                              <th>Sl. No.</th>
                              <th> Win Coupon </th>
                              {/* <th> {`Area `}</th> */}
                              {selectedCampaign?.enable_super_ball === "Y" && (
                                <>
                                  <th>Straight super prize Count</th>
                                  <th>Straight super ball Amt.</th>
                                </>
                              )}
                              {(parseInt(PARAMS?.lotto_type) === 5 ||
                                parseInt(PARAMS?.lotto_type) === 4 ||
                                parseInt(PARAMS?.lotto_type) === 3) && (
                                <>
                                  {(selectedCampaign?.straight_settings_default_check ===
                                    "Checked" ||
                                    PARAMS?.straight === true) && (
                                    <>
                                      <th>Straight Count</th>
                                      <th>Straight Amt.</th>
                                    </>
                                  )}

                                  {selectedCampaign?.enable_super_ball ===
                                    "Y" && (
                                    <>
                                      <th>Rumble super prize Count</th>
                                      <th>Rumble super ball Amt.</th>
                                    </>
                                  )}
                                  {(selectedCampaign?.rumble_settings_default_check ===
                                    "Checked" ||
                                    PARAMS?.rumble === true) && (
                                    <>
                                      <th>Rumble Count</th>
                                      <th>Rumble Amt.</th>
                                    </>
                                  )}
                                </>
                              )}

                              {selectedCampaign?.enable_super_ball === "Y" && (
                                <>
                                  <th>{`Chance super ball count`}</th>
                                  <th>{`Chance super ball amt.`}</th>
                                </>
                              )}

                              {PARAMS?.lotto_type
                                ? Array.from(
                                    { length: PARAMS?.lotto_type },
                                    (_, i) => PARAMS?.lotto_type - i,
                                  ).map((matchIndex) => {
                                    if (
                                      // PARAMS?.lotto_type >= 5 && matchIndex < 3
                                      // (PARAMS?.lotto_type === 5 && matchIndex < 3) ||
                                      // (PARAMS?.lotto_type === 5 && PARAMS?.type === "rumble_mix" && matchIndex < 2 && PRIZEDATA[`${PARAMS?.type}_prize${matchIndex}`] > 0) ||
                                      // (PARAMS?.lotto_type === 6 && matchIndex < 3) ||
                                      // (PARAMS?.lotto_type === 7 && matchIndex < 3)
                                      PRIZEDATA[
                                        `${PARAMS?.type}_prize${matchIndex}`
                                      ] === 0
                                    ) {
                                      return null;
                                    } else {
                                      return (
                                        <React.Fragment key={matchIndex}>
                                          <th>
                                            {`${matchIndex} ${PARAMS?.type_ana} Count`}
                                          </th>
                                          <th>{`${matchIndex} ${PARAMS?.type_ana} Amt.`}</th>
                                        </React.Fragment>
                                      );
                                    }
                                  })
                                : null}

                              {/* {(parseInt(PARAMS?.lotto_type) === 6 && parseInt(selectedCampaign?.lotto_range_start) === 1 && parseInt(selectedCampaign?.lotto_range_end) === 27) && (<>
                                <th>
                                  {`2 ${PARAMS?.type} Count`}
                                </th>
                                <th>{`2 ${PARAMS?.type} Amt.`}</th>
                                </>)} */}

                              <th>Total Count</th>
                              <th onClick={() => handleSort()}>Total Amt.</th>
                            </tr>
                          </thead>

                          <tbody>
                            {filteredData?.length > 0 ? (
                              filteredData.map((items, index) => {
                                let totalCount = 0;
                                totalCount += items?.straight || 0;
                                totalCount += items?.rumble || 0;
                                return (
                                  <tr
                                    key={index}
                                    onClick={() =>
                                      console.log("items : ", items)
                                    }
                                  >
                                    <td>{SKIP + index + 1}</td>
                                    <td>{items?.ticket?.join(",")}</td>
                                    {/* <td>{items?.area?.substr(1,15)}</td> */}
                                    {selectedCampaign?.enable_super_ball ===
                                      "Y" && (
                                      <>
                                        <td>
                                          {items?.straight_super_ball}
                                          {parseInt(
                                            items?.straight_super_ball,
                                          ) > 0 && (
                                            <button
                                              type="button"
                                              className="btn btn-info"
                                              onClick={() =>
                                                handleViewUsers(
                                                  items,
                                                  "straight_super_ball",
                                                )
                                              }
                                            >
                                              View
                                            </button>
                                          )}
                                        </td>
                                        <td>
                                          {items?.straight_super_ball *
                                            PRIZEDATA[`straight_super_prize`]}
                                        </td>
                                      </>
                                    )}

                                    {(parseInt(PARAMS?.lotto_type) === 5 ||
                                      parseInt(PARAMS?.lotto_type) === 4 ||
                                      parseInt(PARAMS?.lotto_type) === 3) && (
                                      <>
                                        {(selectedCampaign?.straight_settings_default_check ===
                                          "Checked" ||
                                          PARAMS?.straight === true) && (
                                          <>
                                            <td>
                                              {items?.straight}
                                              {parseInt(items?.straight) >
                                                0 && (
                                                <button
                                                  type="button"
                                                  className="btn btn-info"
                                                  onClick={() =>
                                                    handleViewUsers(
                                                      items,
                                                      "straight",
                                                    )
                                                  }
                                                >
                                                  View
                                                </button>
                                              )}
                                            </td>
                                            <td>
                                              {items?.straight *
                                                PRIZEDATA[
                                                  `stright_prize${PARAMS?.lotto_type}`
                                                ]}
                                            </td>
                                          </>
                                        )}

                                        {selectedCampaign?.enable_super_ball ===
                                          "Y" && (
                                          <>
                                            <td>
                                              {items?.rumble_super_ball}
                                              {parseInt(
                                                items?.rumble_super_ball,
                                              ) > 0 && (
                                                <button
                                                  type="button"
                                                  className="btn btn-info"
                                                  onClick={() =>
                                                    handleViewUsers(
                                                      items,
                                                      "rumble_super_ball",
                                                    )
                                                  }
                                                >
                                                  View
                                                </button>
                                              )}
                                            </td>
                                            <td>
                                              {items?.rumble_super_ball *
                                                PRIZEDATA[`rumble_super_prize`]}
                                            </td>
                                          </>
                                        )}
                                        {(selectedCampaign?.rumble_settings_default_check ===
                                          "Checked" ||
                                          PARAMS?.rumble === true) && (
                                          <>
                                            <td>
                                              {items?.rumble}
                                              {items?.rumble > 0 && (
                                                <button
                                                  type="button"
                                                  className="btn btn-info"
                                                  onClick={() =>
                                                    handleViewUsers(
                                                      items,
                                                      "rumble",
                                                    )
                                                  }
                                                >
                                                  View
                                                </button>
                                              )}
                                            </td>
                                            <td>
                                              {items?.rumble *
                                                PRIZEDATA[
                                                  `rumble_mix_prize${PARAMS?.lotto_type}`
                                                ]}
                                            </td>
                                          </>
                                        )}
                                      </>
                                    )}

                                    {selectedCampaign?.enable_super_ball ===
                                      "Y" && (
                                      <>
                                        <td>
                                          {items?.chance_super_ball}
                                          {parseInt(items?.chance_super_ball) >
                                            0 && (
                                            <button
                                              type="button"
                                              className="btn btn-info"
                                              onClick={() =>
                                                handleViewUsers(
                                                  items,
                                                  "chance_super_ball",
                                                )
                                              }
                                            >
                                              View
                                            </button>
                                          )}
                                        </td>
                                        <td>
                                          {items?.chance_super_ball *
                                            PRIZEDATA[`chance_super_prize`]}
                                        </td>
                                      </>
                                    )}

                                    {PARAMS?.lotto_type
                                      ? Array.from(
                                          { length: PARAMS?.lotto_type },
                                          (_, i) => PARAMS?.lotto_type - i,
                                        ).map((matchIndex) => {
                                          if (
                                            // PARAMS?.lotto_type >= 5 && matchIndex < 3
                                            // (PARAMS?.lotto_type === 5 && matchIndex < 3) ||
                                            // (PARAMS?.lotto_type === 5 && PARAMS?.type === "rumble_mix" && matchIndex < 2 && PRIZEDATA[`${PARAMS?.type}_prize${matchIndex}`] > 0) ||
                                            // (PARAMS?.lotto_type === 6 && matchIndex < 3) ||
                                            // (PARAMS?.lotto_type === 7 && matchIndex < 3)
                                            PRIZEDATA[
                                              `${PARAMS?.type}_prize${matchIndex}`
                                            ] === 0
                                          )
                                            return null;
                                          totalCount +=
                                            parseInt(
                                              items[`match${matchIndex}`],
                                            ) || 0;
                                          return (
                                            <React.Fragment key={matchIndex}>
                                              <td>
                                                {items[`match${matchIndex}`]}
                                                {items[`match${matchIndex}`] >
                                                  0 && (
                                                  <button
                                                    type="button"
                                                    className="btn btn-info"
                                                    onClick={() =>
                                                      handleViewUsers(
                                                        items,
                                                        `match${matchIndex}`,
                                                      )
                                                    }
                                                  >
                                                    View
                                                  </button>
                                                )}
                                              </td>
                                              <td>
                                                {items[`match${matchIndex}`] *
                                                  PRIZEDATA[
                                                    `${PARAMS?.type}_prize${matchIndex}`
                                                  ]}
                                              </td>
                                            </React.Fragment>
                                          );
                                        })
                                      : null}

                                    {/* {(parseInt(PARAMS?.lotto_type) === 6 && parseInt(selectedCampaign?.lotto_range_start) === 1 && parseInt(selectedCampaign?.lotto_range_end) === 27) && (<>
                                        <td>
                                          {items[`match2`]}
                                          {items[`match2`] > 0 && (
                                            <button type="button" className="btn btn-info" onClick={()=> handleViewUsers(items, `match2`)}>View</button>
                                          )}
                                        </td>
                                        <td>
                                          {items[`match2`] * PRIZEDATA[`${PARAMS?.type}_prize2`]}
                                        </td>
                                      </>)} */}

                                    <td>
                                      {totalCount > 0 && (
                                        <button
                                          type="button"
                                          className="btn btn-info-total"
                                          onClick={() =>
                                            handleViewUsers(items, "all")
                                          }
                                        >{`${totalCount} View`}</button>
                                      )}
                                    </td>
                                    <td>{items?.total_amount || 0}</td>
                                  </tr>
                                );
                              })
                            ) : isLoading ? (
                              <SkeltonList row={5} col={15} />
                            ) : (
                              <tr>
                                <td colSpan="12" className="img-center">
                                  No data found!
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </VendorList>
          </Box>
        </div>
      </div>
      <Loading
        isLoading={pageLoading}
        text="Preparing matches! Please wait..."
      />
      <Loading
        isLoading={detailsLoading}
        text="Fetching details! Please wait..."
      />
      <ManageAreasPopup
        open={manageAreasOpen}
        onClose={() => setManageAreasOpen(false)}
        areas={analyserAreas}
        onSave={handleSaveAreas}
        saving={areasSaving}
      />
      {/* <Loading isLoading={exportLoading} text="Preparing excel! Please wait..."/> */}
      {usersDetails && usersDetails?.length > 0 && (
        <PreviewPopUp
          popUpOpen={true}
          togglePopUp={setUsersDetails}
          usersDetails={usersDetails}
        />
      )}

      {finalData && finalData?.length > 0 && (
        <FinalPopup
          popUpOpen={true}
          togglePopUp={setFinalData}
          usersDetails={finalData}
          campaignData={selectedCampaign || {}}
          matchingCode={matchingCode || ""}
          otherData={otherData || {}}
        />
      )}

      {/* <OtpConfirmPopup popUpOpen={isOtpPopup} togglePopUp={toggleIsPopup} setTwoFactorVerify={setTwoFactorVerify} /> */}

      {/* Export Loading */}
      {exportLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            zIndex: 1000,
          }}
        >
          <div style={{ textAlign: "center" }}>
            <Spin size="large" />
            <p style={{ marginTop: 16, display: "block" }}>
              {exportLoadingText || "Loading, please wait..."}
            </p>
          </div>
        </div>
      )}
    </>
  );
}
